// extracted by mini-css-extract-plugin
export var productionHolder = "production-module--productionHolder--bnNz8";